/**
 * 导出用到的公用函数
 */
export default {
    methods: {
        /**
         * 导出的数据请求
         * @api 请求地址
         * @params 请求参数
         */
        exportHttp (api, params) {
            this.$api.query(api, params, null, true).then((rs) => {
                if (this.loading) {
                    this.loading = false
                }
                let fileName = 'excel.xlsx'
                // 获取文件夹名称
                let disposition = rs.headers['content-disposition'] || ''
                if (disposition.length > 0) {
                    let strReg = 'filename='
                    let index = disposition.indexOf(strReg)
                    fileName = disposition.substring(index + strReg.length, disposition.length)
                    fileName = fileName.replace(/\"/g, "")
                }
                this.downFile(rs.data, fileName)
            }).catch(() => {
                if (this.loading) {
                    this.loading = false
                }
                this.$Message.error({content: '下载失败，稍后再试～', duration: 5 })
            })
        },
        downFile (blob, fileName) {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/export.mixin.js